import React, { useContext } from 'react';
import ChannelContext from '@jetshop/core/components/ChannelContext';
import { Helmet } from 'react-helmet-async';

function getBrand(product) {
  const field = product?.customFields?.find(({ key }) => key === 'brand');
  if (field) {
    return field.stringValue;
  }
}

export function ProductMeta({ product, selectedVariation }) {
  const { selectedChannel } = useContext(ChannelContext);

  const prod = selectedVariation || product;
  const brand = getBrand(product);

  return (
    <Helmet>
      <meta property="og:title" content={product.name} />
      <meta
        property="product:original_price:amount"
        content={prod?.price?.incVat}
      />
      <meta
        property="product:price:amount"
        content={prod?.previousPrice?.incVat}
      />
      <meta
        property="og:price:currency"
        content={selectedChannel.currency.id}
      />
      {product?.images?.length > 0 && (
        <meta property="og:image" content={product.images[0].url} />
      )}
      <meta
        property="product:availability"
        content={prod?.stockStatus?.buyable ? 'instock' : 'oos'}
      />
      {brand && <meta property="product:brand" content={brand} />}
      <meta
        property="product:category"
        content={product.canonicalCategory && product.canonicalCategory.name}
      />
      <meta
        property="og:url"
        content={`${selectedChannel.url}${product?.primaryRoute?.path}`}
      />
    </Helmet>
  );
}
